import dynamic from 'next/dynamic';
import React from 'react';

import { ArrowRight } from '@/assets/icons/Icons';

import Footer from './Footer';
import FormattedText from './FormattedText';
import Header from './Header';
import NewReviews from './NewReviews';
import Page from './Page';
import Stats from './Stats';

export const HubSpotDynamicScriptComponent = dynamic(
  () => import('../components/script/HubSpotMeetingScript'),
  {
    ssr: true,
  }
);

const DemoMeeting = () => {
  const talkAboutList = [
    {
      value: 'Your current payment setup to see what is/isn’t working',
    },
    {
      value:
        'Increasing revenue with optimized checkout and post-purchase automations',
    },
    {
      value:
        'Your current processes and how we can fit FormPay solution into the existing setup',
    },
    {
      value:
        'If we feel FormPay is a great fit, develop an improvement plan and start FormPay account',
    },
  ];

  return (
    <section>
      <Page title='Schedule Meeting | FormPay' />
      <Header />
      <section
        className={`tw-mt-[80px] tw-flex  tw-flex-col tw-bg-[#F9F5FE] tw-pt-12 lg:tw-pt-32`}
      >
        <section className='tw-mx-auto tw-my-8'>
          <section
            tabIndex={0}
            className='tw-h-auto tw-w-[390px] tw-text-center tw-text-[34px] tw-font-fontMoreBold tw-leading-[42px] tw-tracking-[-0.03em] tw-text-blueDark sm:tw-w-[600px] md:tw-w-[700px] md:tw-text-[44px] md:tw-leading-[54px] lg:tw-w-[1024px] lg:tw-text-[52px] lg:tw-leading-[64px]'
          >
            Schedule a Demo with FormPay{' '}
          </section>
        </section>
        <section className='tw-mx-auto tw-my-8'>
          <p
            tabIndex={0}
            className='tw-h-auto tw-w-[390px] tw-text-center tw-text-largeText tw-font-fontLight tw-leading-[28px] tw-text-darkGrey sm:tw-w-[600px] md:tw-w-[700px] md:tw-leading-[26px] lg:tw-w-[1024px]'
          >
            Connect your favorite gateway with HubSpot using FormPay. Collect,
            track, manage and{' '}
            <span className='tw-text-largeText tw-font-fontLight tw-leading-[28px] tw-text-darkGrey md:tw-leading-[26px]'>
              automate your one-time or recurring payment data within HubSpot.
            </span>
          </p>
        </section>
      </section>
      <div className='tw-mx-[11px] tw-grid tw-max-w-[1024px] tw-grid-cols-12 tw-px-3 sm:tw-px-6 md:tw-m-11 lg:tw-mt-[11px] lg:tw-max-w-[1200px] xl:tw-mx-auto'>
        <section className='tw-col-span-12 tw-mt-48 tw-flex tw-flex-col tw-gap-5 md:tw-col-span-7'>
          <h2 className='tw-text-[30px] tw-font-[600] tw-text-[#1C2433]'>
            Thank you for your interest in FormPay!
          </h2>
          <p className='tw-pt-[20px] tw-text-[22px] tw-text-[#677289]'>
            Schedule a 30-minute demo of FormPay and see how you can utilize
            HubSpot to the highest potential
          </p>

          <p className='tw-pt-[20px] tw-text-[22px] tw-text-[#677289]'>
            During your demo {`we'll`} talk about:
          </p>
          <section className='tw-ml-[10px] tw-text-[18px]  tw-text-[#677289]'>
            {talkAboutList.map((item, index) => (
              <p className='tw-flex' key={index}>
                <span className='tw-mr-[5px] tw-mt-[10px] tw-h-[6px] tw-w-[6px] tw-rounded-full tw-bg-[#677289] max-sm:tw-h-[4px] max-sm:tw-w-[8px]'>
                  {}
                </span>
                {item.value}
              </p>
            ))}
          </section>
          <p className='tw-mt-[32px] tw-flex tw-items-center tw-gap-[5px] tw-text-[24px]'>
            Please select a date and time that works best with your schedule
            <ArrowRight />
          </p>
        </section>
        <section className='tw-col-span-12 tw-ml-40 tw-mt-48 tw-flex tw-flex-col tw-gap-5 md:tw-col-span-5'>
          <HubSpotDynamicScriptComponent />
        </section>
      </div>

      <Stats />
      <FormattedText
        childClassNames='tw-h-[1px] tw-w-[85vw] tw-bg-lightGrey4 tw-my-4'
        parentClassNames='tw-my-8'
      >
        {}
      </FormattedText>
      <div className='tw-mx-[11px] tw-max-w-[1024px] tw-px-3 sm:tw-px-6 lg:tw-mt-[11px] lg:tw-max-w-[1200px]  xl:tw-mx-auto'>
        <NewReviews />
      </div>
      <section className='tw-mt-60'>
        <Footer />
      </section>
    </section>
  );
};

export default DemoMeeting;
